import renderEmpty from './renderEmpty';
import { renderErrorObject } from './renderErrorObject';

export {
    renderEmpty,
    renderErrorObject,
};


// WEBPACK FOOTER //
// ./src/components/widget/common/Render/index.ts